import { createBidirectionalMap } from './bidirectionalMap';
import type { PipelineType } from './types.generated';

export const pipelineTypeMap = createBidirectionalMap<PipelineType>()({
  STANDARD: 'standard',
  SERVICE: 'service',
});
